@if (shouldDisplayImport) {
  <div class="custom-header-content">
    <div class="custom-header-title">
      <typography id="quoteTitle" variant="mat-headline-6" weight="bold"> {{ appStrings.label_importQuote }}</typography>
    </div>
    <div class="custom-header-buttons">
      <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="goBackButton" (onClick)="goToInitialQuote()"
        [label]="appStrings.button_back">
      </ds-button>
      <ds-button class="half-width" size="large" type="primary" variant="label-only" id="importOrderButton" (onClick)="importQuotesOrders()"
        [label]="appStrings.button_importQuote" [isDisabled]="!isImportEnabled">
      </ds-button>
    </div>
  </div>
}

<!-- Spinner and overlay, while importing the quote or order -->
@if (importLoading || checkSelectedQuoteForConsignedItemsLoading) {
  <div id="loadingContainer" class="overlay full">
    <p class="text-center"> {{appStrings.pleaseWait}} </p>
    <ds-progress-spinner id="importLoader" progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
